import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";

/**
 * Botón PayPal para cambio de plan de perfil promocional.
 *
 * La orden de PayPal la crea el SERVIDOR (en /api/renewals/create-profile-change-plan-order)
 * y se pasa como prop `orderId`. Este componente únicamente:
 *   1. Devuelve ese orderId al SDK de PayPal (sin crear una nueva orden cliente-side).
 *   2. Tras la aprobación del usuario, llama al servidor para capturar el pago.
 *      El servidor verifica con PayPal el monto real capturado y escribe en Firestore.
 */
export default function PayPalButtonChangePlan({
  clientId,
  price,
  userId,
  planType,
  profileId,
  orderId,      // orderId ya creado por el servidor
  onSuccess,
  onError,
}) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  // Simplemente devolvemos el orderId que el servidor ya creó.
  // Esto evita que el cliente cree una orden con un precio arbitrario.
  const createOrder = () => {
    return Promise.resolve(orderId);
  };

  // El usuario aprobó el pago en PayPal. Llamamos al servidor para capturar.
  // El servidor contacta a PayPal directamente y verifica el monto real capturado.
  // NO llamamos actions.order.capture() aquí para evitar doble captura.
  const onApprove = async (data) => {
    try {
      const response = await axios.post(
        `${backendUrl}/api/renewals/capture-profile-change-plan-order`,
        {
          orderID: data.orderID,
          userId,
          amount: price,
          planType,
          profileId,
        }
      );

      if (response.data.success) {
        onSuccess({
          orderId: data.orderID,
          expirationDate: response.data.expirationDate,
          planType: response.data.planType,
        });
      } else {
        onError({
          message: response.data.error || "Error al capturar la orden en el servidor.",
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.status === 400 && error.response?.data?.error
          ? error.response.data.error
          : "Error al procesar el pago con PayPal. Por favor, intenta de nuevo.";
      onError({ message: errorMessage });
    }
  };

  return (
    <PayPalScriptProvider options={{ "client-id": clientId, currency: "USD" }}>
      <PayPalButtons
        createOrder={createOrder}
        onApprove={onApprove}
        onError={(err) =>
          onError({
            message:
              "Error con PayPal: " +
              (err.message || "Error desconocido. Por favor, intenta de nuevo."),
          })
        }
        style={{ layout: "vertical" }}
      />
    </PayPalScriptProvider>
  );
}
